module.exports = __webpack_public_path__ + "img/202412100202.eb087f55.png";